export function getNumber(name) {
  return name.split(" ")[1];
}
